import Worker from 'worker-loader!./worker';
import * as Comlink from 'comlink';

let worker = new Worker();
let comlinkWrap = Comlink.wrap(worker)

// function help kill ternimate
export const terminateWorker = () => {
    worker.terminate()
}

export const calcUserDataCsv = comlinkWrap.calcUserDataCsv;
export const showMessageUserGeofences = comlinkWrap.showMessageUserGeofences;
export const linkedDeviceDetect = comlinkWrap.linkedDeviceDetect;